import { configuration } from "src/configuration";
import { EditTaskItemParentDto, FetchError } from "src/http";
import { useTaskItemMutation } from "src/http/hooks/taskItems/useTaskItemMutation";
import { useAccessToken } from "src/http/use-access-token";

type Variables = {
  taskItemGuid: string;
  parentTaskItemGuid: string | null;
  teamSlug?: string;
  ownerUserGuids: string[];
};

const useEditTaskItemParentRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function editTaskItemParentRequest(variables: Variables) {
    const accessToken = await getAccessToken();
    const body: EditTaskItemParentDto = {
      parentTaskItemGuid: variables.parentTaskItemGuid,
    };

    const response = await fetch(`${configuration.apiRootUrl}/task-items/${variables.taskItemGuid}/parent`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      method: "put",
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { editTaskItemParentRequest };
};

const useEditTaskItemParent = () => {
  const { editTaskItemParentRequest } = useEditTaskItemParentRequest();

  return useTaskItemMutation({
    mutationFn: editTaskItemParentRequest,
  });
};

export { useEditTaskItemParent };
